import { connect } from 'react-redux';
import { isAuthorised } from '../../../../../store/general/selectors';
import { IState } from '../../../../../store/types';
import { getAudioById, getNativeLanguage, isUserGroupsLoaded } from '../../../../../store/models/selectors';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { getAudioExercises, getExerciseNatives, isExerciseGenerateFailed, isExerciseGenerating, isExercisesLoadFailed } from '../../../../../store/exercises/selectors';
import { hasUsableTranscript } from '../../../../../../common/utils/audioTranscriptUtil';
import { EMPTY_ARRAY } from '../../../../../../common/types';
import { ExercisesTab } from '../components/ExercisesTab';
import { IExercisesTabEvents, IExercisesTabFields } from '../components/types';
import { ExercisesTabEvents } from './events';

const mapStateToProps = (
	state: IState
): IExercisesTabFields => {
	const audioId = getCurrentAudioId(state);
	const audio = audioId ? getAudioById(state, audioId) : undefined;
	const data = audioId ? getAudioExercises(state, audioId) : undefined;
	const types = data?.types || EMPTY_ARRAY;
	return {
		// only once the user is in the store too — REST calls reject before that
		audioId: audioId && isAuthorised(state) ? audioId : undefined,
		audioLoaded: !!audio || isUserGroupsLoaded(state),
		hasTranscript: hasUsableTranscript(audio),
		langCode: audio?.language?.code,
		loaded: !!data,
		loadFailed: audioId ? isExercisesLoadFailed(state, audioId) : false,
		types,
		exercises: data?.exercises || EMPTY_ARRAY,
		myAnswers: data?.myAnswers || EMPTY_ARRAY,
		canRegenerate: !!data?.canRegenerate,
		generatingPromptIds: audioId
			? types.filter(t => isExerciseGenerating(state, audioId, t.promptId)).map(t => t.promptId)
			: EMPTY_ARRAY,
		generateFailedPromptIds: audioId
			? types.filter(t => isExerciseGenerateFailed(state, audioId, t.promptId)).map(t => t.promptId)
			: EMPTY_ARRAY,
		students: data?.students || EMPTY_ARRAY,
		studentAnswers: data?.studentAnswers || EMPTY_ARRAY,
		nativeLangCode: getNativeLanguage(state)?.code,
		exerciseNatives: getExerciseNatives(state),
	};
}

const mapDispatchToProps = (
	dispatch: any
): IExercisesTabEvents => ({
	onLoad: () => dispatch(ExercisesTabEvents.onLoad()),
	onGenerate: (promptId, level) => dispatch(ExercisesTabEvents.onGenerate(promptId, level)),
	onAnswer: (exerciseId, questionIndex, answer) => dispatch(ExercisesTabEvents.onAnswer(exerciseId, questionIndex, answer)),
	onClearAnswers: (exerciseId, userId) => dispatch(ExercisesTabEvents.onClearAnswers(exerciseId, userId)),
	onLoadStudents: () => dispatch(ExercisesTabEvents.onLoadStudents()),
	onLoadNative: (exerciseId) => dispatch(ExercisesTabEvents.onLoadNative(exerciseId)),
	onSetStatus: (exerciseId, status) => dispatch(ExercisesTabEvents.onSetStatus(exerciseId, status)),
});

export const ExercisesTabHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(ExercisesTab);

ExercisesTabHOC.displayName = 'ExercisesTabHOC';
